import React from 'react';
import * as RadioGroup from '@radix-ui/react-radio-group';
import { ReactComponent as RadioChecked } from '../../assets/img/radio-checked.svg';
import * as Tooltip from '@radix-ui/react-tooltip';

const NestedRadioInputs = ({ items, value, setValue }) => {
  let isTextTruncated = function (id) {
    let element = document.querySelector(`#${id}`);

    if (!element) {
      return;
    }

    const temp = element.cloneNode(true);

    temp.style.position = 'fixed';
    temp.style.overflow = 'visible';
    temp.style.whiteSpace = 'nowrap';
    temp.style.visibility = 'hidden';

    element.parentElement.appendChild(temp);

    try {
      const fullWidth = temp.getBoundingClientRect().width;
      const displayWidth = element.getBoundingClientRect().width;

      return displayWidth < fullWidth;
    } finally {
      temp.remove();
    }
  };

  return (
    <Tooltip.Provider
      delayDuration={500}
      skipDelayDuration={0}
      disableHoverableContent='true'
    >
      <form>
        <RadioGroup.Root
          className='flex flex-col items-start pr-5 text-blue-500'
          defaultValue='overall_socioeconomic'
          aria-label='Socioeconomic factors'
          value={value}
          onValueChange={(value) => {
            if (value) {
              setValue(value);
            }
          }}
          data-component-name='NestedRadioInputs'
        >
          {/* Overall socioeconomic feature. */}
          {items &&
            items
              .filter((featureCategory) => featureCategory.category === 'overall')
              .map((featureCategory, i) => {
                return (
                  <div
                    className='flex items-center gap-[9px] border-b border-solid border-blue-50 w-full pb-2.5'
                    key={`${i}`}
                  >
                    <RadioGroup.Item
                      className='relative w-4 h-4 border border-blue-100 border-solid rounded-full outline-none cursor-default bg-white-400'
                      value={featureCategory.features[0].id}
                      id={`r-overall`}
                    >
                      <RadioGroup.Indicator className='top-0 left-0 block -translate-x-px -translate-y-px abolute'>
                        <RadioChecked />
                      </RadioGroup.Indicator>
                    </RadioGroup.Item>
                    <label
                      className='block text-sm font-bold leading-4 opacity-80'
                      htmlFor={`r-overall`}
                    >
                      {featureCategory.features[0].label}
                    </label>
                  </div>
                );
              })}

          {/* Rest of the features. */}
          {items &&
            items
              .filter(
                (featureCategory) =>
                  featureCategory.category !== 'overall' &&
                  featureCategory.category !== 'broadband'
              )
              .map((featureCategory, i) => (
                <div className='flex flex-col items-start max-w-full pt-4 pb-1' key={i}>
                  <Tooltip.Root className='max-w-full'>
                    <div className='flex items-center gap-[9px] py-[5px]'>
                      <RadioGroup.Item
                        className='relative flex-shrink-0 w-4 h-4 border border-blue-100 border-solid rounded-full outline-none cursor-default bg-white-400'
                        value={featureCategory.category}
                        id={`r-${i}`}
                      >
                        <RadioGroup.Indicator className='top-0 left-0 block -translate-x-px -translate-y-px abolute'>
                          <RadioChecked />
                        </RadioGroup.Indicator>
                      </RadioGroup.Item>

                      <Tooltip.Trigger className='' asChild>
                        <label
                          className='block text-sm leading-4 opacity-80'
                          htmlFor={`r-${i}`}
                          id={`r-${i}-label`}
                        >
                          {featureCategory.category}
                        </label>
                      </Tooltip.Trigger>
                      <Tooltip.Content>
                        {isTextTruncated(`r-${i}-label`) && (
                          <div className='max-w-full px-4 py-2 text-sm text-blue-500 rounded-md shadow-md pointer-events-none bg-blue-50'>
                            {featureCategory.category}
                          </div>
                        )}
                      </Tooltip.Content>
                    </div>
                  </Tooltip.Root>

                  {featureCategory.features && (
                    <div className='flex flex-col items-start justify-start max-w-full px-4 pt-px'>
                      {featureCategory.features.map((feature, j) => (
                        <div
                          className='flex flex-col items-start max-w-full py-[5px]'
                          key={j}
                        >
                          <Tooltip.Root className='w-full max-w-full'>
                            <div className='flex items-center gap-[9px] relative w-full'>
                              <RadioGroup.Item
                                className='relative flex-shrink-0 w-4 h-4 border border-blue-100 border-solid rounded-full outline-none cursor-default bg-white-400'
                                value={feature.id}
                                id={`r-${i}-${j}`}
                              >
                                <RadioGroup.Indicator className='top-0 left-0 block -translate-x-px -translate-y-px abolute'>
                                  <RadioChecked />
                                </RadioGroup.Indicator>
                              </RadioGroup.Item>

                              <Tooltip.Trigger asChild className='w-full max-w-full'>
                                <label
                                  className='block max-w-full text-sm leading-4 truncate opacity-80'
                                  htmlFor={`r-${i}-${j}`}
                                  id={`r-${i}-${j}-label`}
                                >
                                  {feature.label}
                                </label>
                              </Tooltip.Trigger>

                              <Tooltip.Content className='w-full max-w-[300px]'>
                                {isTextTruncated(`r-${i}-${j}-label`) && (
                                  <div className='w-full max-w-full px-4 py-2 text-sm text-blue-500 rounded-md shadow-md pointer-events-none bg-blue-50'>
                                    {feature.label}
                                  </div>
                                )}
                              </Tooltip.Content>
                            </div>
                          </Tooltip.Root>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
        </RadioGroup.Root>
      </form>
    </Tooltip.Provider>
  );
};

export default NestedRadioInputs;
